import { newsApi } from './api';

export const DispatcherService = newsApi.injectEndpoints({
    endpoints: (build) => ({
        getDispatchers: build.query({
            query: ({ id, pagination }) => ({
                url: `users/${id}${pagination && pagination}`,
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                },
            }),
            providesTags: ['Driver'],
        }),
        addDispatcher: build.mutation({
            query: (form) => ({
                url: `users/store`,
                method: 'POST',
                body: form,
                headers: {
                    'Accept': 'application/json',
                },
            }),
            invalidatesTags: ['Driver'],
        }),
        editDispatcher: build.mutation({
            query: ({ id, newForm }) => ({
                url: `users/update/${id}`,
                method: 'PATCH',
                body: newForm,
                headers: {
                    'Accept': 'application/json',
                },
            }),
            invalidatesTags: ['Driver'],
        }),
        removeDispatcher: build.mutation({
            query: (id) => ({
                url: `users/delete/${id}`,
                method: 'DELETE',
                headers: {
                    'Accept': 'application/json',
                },
            }),
            invalidatesTags: ['Driver'],
        }),
    }),
    overrideExisting: false,
})

export const {
    useGetDispatchersQuery,
    useAddDispatcherMutation,
    useEditDispatcherMutation,
    useRemoveDispatcherMutation,
} = DispatcherService